import { createAsyncThunk } from '@reduxjs/toolkit';
import institutionService from 'api/institutionService';
import submissionService from 'api/submissionService';
import { notifyApiError } from 'api/apiUtils';
import { notifyError, notifySuccess } from 'utils/notifications';

export const getSubmissions = createAsyncThunk(
  'submissions/getSubmissions',
  async (payload, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.getSubmissions(payload);
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const getSubmissionsCalendar = createAsyncThunk(
  'submissions/getSubmissionsCalendar',
  async (payload, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.getSubmissionsCalendar(payload);
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const getInstitutionUsers = createAsyncThunk(
  'submissions/getInstitutionUsers',
  async (institutionId, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.getInstitutionUsers(
        institutionId
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const uploadListFile = createAsyncThunk(
  'submissions/uploadListFile',
  async ({ submissionId, payload }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await submissionService.uploadSubmissionFile(
        submissionId,
        payload
      );
      if (response === 'OK') {
        notifySuccess(
          i18n.t('datagate.external.submissions.message.uploadSuccess')
        );
        return response;
      } else if (response === 'VIRUS_FOUND') {
        notifyError(i18n.t('datagate.external.upload.error.virusFound'));
        return rejectWithValue(response);
      } else {
        notifyError(i18n.t('datagate.external.upload.error.unknown'));
        return rejectWithValue(response);
      }
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);
